'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_emerald', {
      url: '/tvs_emerald',
      template: '<tvsemeraldtab></tvsemeraldtab>',
      authenticate: 'admin'
    });
}
